export default __webpack_public_path__ + "static/Augmented-Reality-44f026fcdbfc3359cbbbcf3cb53993bc.webp";